export default Object.freeze({
  EducationDepartmentId: 472,
});
